module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_d2b89a61.4c6de766.eot";